exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".not-active {\r\n    pointer-events: none;\r\n    cursor: default;\r\n}\r\n.breadcrumb-item {\r\n    float: left;\r\n}", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// D:/Angular projects/memberreg/memberreg/src/app/layouts/admin/breadcrumbs/breadcrumbs.component.css
// module id = ../../../../../src/app/layouts/admin/breadcrumbs/breadcrumbs.component.css
// module chunks = main